export default [
  {
    path: "/member",
    name: "member",
    component: () => import("@/views/member/Member.vue"),
    meta: {
      pageTitle: "Member",
      breadcrumb: [
        {
          text: "Member",
          active: true,
        },
      ],
      middleware: "Auth",
    },
  },
  {
    path: "/member",
    name: "member-status-1",
    component: () => import("@/views/member/Member.vue"),
    beforeEnter: (to, from, next) => {
      if (!to.query.status) {
        next({ path: to.path, query: { status: "1", page: "1" } });
      } else {
        next();
      }
    },
    meta: {
      pageTitle: "Member Pre Register",
      breadcrumb: [
        {
          text: "Member",
          active: true,
        },
      ],
      middleware: "Auth",
    },
  },
  {
    path: "/member",
    name: "member-status-2",
    component: () => import("@/views/member/Member.vue"),
    beforeEnter: (to, from, next) => {
      if (!to.query.status) {
        next({ path: to.path, query: { status: "2", page: "1" } });
      } else {
        next();
      }
    },
    meta: {
      pageTitle: "Member Registered",
      breadcrumb: [
        {
          text: "Member",
          active: true,
        },
      ],
      middleware: "Auth",
    },
  },
  {
    path: "/member",
    name: "member-status-3",
    component: () => import("@/views/member/Member.vue"),
    beforeEnter: (to, from, next) => {
      if (!to.query.status) {
        next({ path: to.path, query: { status: "3", page: "1" } });
      } else {
        next();
      }
    },
    meta: {
      pageTitle: "Member Verified",
      breadcrumb: [
        {
          text: "Member",
          active: true,
        },
      ],
      middleware: "Auth",
    },
  },
  {
    path: "/member",
    name: "member-status-4",
    component: () => import("@/views/member/Member.vue"),
    beforeEnter: (to, from, next) => {
      if (!to.query.status) {
        next({ path: to.path, query: { status: "4", page: "1" } });
      } else {
        next();
      }
    },
    meta: {
      pageTitle: "Member Unverified",
      breadcrumb: [
        {
          text: "Member",
          active: true,
        },
      ],
      middleware: "Auth",
    },
  },
  {
    path: "/member",
    name: "member-status-5",
    component: () => import("@/views/member/Member.vue"),
    beforeEnter: (to, from, next) => {
      if (!to.query.status) {
        next({ path: to.path, query: { status: "5", page: "1" } });
      } else {
        next();
      }
    },
    meta: {
      pageTitle: "Member Active",
      breadcrumb: [
        {
          text: "Member",
          active: true,
        },
      ],
      middleware: "Auth",
    },
  },
  {
    path: "/member",
    name: "member-status-6",
    component: () => import("@/views/member/Member.vue"),
    beforeEnter: (to, from, next) => {
      if (!to.query.status) {
        next({ path: to.path, query: { status: "6", page: "1" } });
      } else {
        next();
      }
    },
    meta: {
      pageTitle: "Member Validated",
      breadcrumb: [{
        text: "Member",
        active: true,
      }],
      middleware: "Auth",
    },
  },
  {
    path: "/log",
    name: "log",
    component: () => import("@/views/log/Log.vue"),
    meta: {
      pageTitle: "Log",
      breadcrumb: [
        {
          text: "Log",
          active: true,
        },
      ],
      middleware: "Auth",
    },
  },
];
